import React from 'react';

import LicenseBack from '../assets/img/sinister/injured_persons_docs_photos/license_back.svg';
import LicenseFront from '../assets/img/sinister/injured_persons_docs_photos/license_front.svg';
import PoliceComplaint from '../assets/img/sinister/injured_persons_docs_photos/police_complaint.svg';
import VehicleDocumentationBack from '../assets/img/sinister/injured_persons_docs_photos/vehicle_documentation_back.svg';
import VehicleDocumentationFront from '../assets/img/sinister/injured_persons_docs_photos/vehicle_documentation_front.svg';

import FinishStep from '../screens/PrivateLayout/Sinister/Steps/FinishStep.component';
import SelectRobbery from '../screens/PrivateLayout/Sinister/Steps/SelectRobbery.component';
import SinisterSummary from '../screens/PrivateLayout/Sinister/Steps/Summary/SinisterSummary.component';
import TypeOfDamage from '../screens/PrivateLayout/Sinister/Steps/TypeOfDamage.component';
import TypeOfTheft from '../screens/PrivateLayout/Sinister/Steps/TypeOfTheft.component';
import Damage from '../screens/PrivateLayout/Sinister/Steps/damage.component';

// import LicenseFront from "../assets/img/license_front.png";
// import LicenseBack from "../assets/img/license_back.png";
// import VehicleDocumentationFront from "../assets/img/vehicle_documentation_front.png";
// import VehicleDocumentationBack from "../assets/img/vehicle_documentation_back.png";
// import PoliceComplaint from "../assets/img/police_complaint.png";

export const IncidentsLabels: any = {
  fire: 'Incendio',
  flood: 'Inundación',
  hail: 'Granizo',
  robbery: 'Robo o hurto',
  damage: 'Daños en mi vehículo',
  crash: 'Accidente o choque',
};

export const IncidentsDocumentsTypes: any = {
  LICENSE: 'license',
  VEHICLE_DOCUMENTATION: 'vehicle_documentation',
  POLICE_COMPLAINT: 'police_complaint',
};

export const IncidentsDocuments: any = [
  {
    type: IncidentsDocumentsTypes.LICENSE,
    side: 'front',
    title: 'Subí una foto del frente de tu registro',
    button: 'Foto del frente de tu registro',
    img: LicenseFront,
  },
  {
    type: IncidentsDocumentsTypes.LICENSE,
    side: 'back',
    title: 'Subí una foto del dorso de tu registro',
    button: 'Foto del dorso de tu registro',
    img: LicenseBack,
  },
  {
    type: IncidentsDocumentsTypes.VEHICLE_DOCUMENTATION,
    side: 'front',
    title: 'Subí una foto del frente de tu cédula verde o azul',
    button: 'Foto del frente de tu cédula verde o azul',
    img: VehicleDocumentationFront,
  },
  {
    type: IncidentsDocumentsTypes.VEHICLE_DOCUMENTATION,
    side: 'back',
    title: 'Subí una foto del dorso de tu cédula verde o azul',
    button: 'Foto del dorso de tu cédula verde o azul',
    img: VehicleDocumentationBack,
  },
  {
    type: IncidentsDocumentsTypes.POLICE_COMPLAINT,
    side: 'front',
    title: 'Subí una foto de la denuncia policial',
    button: 'Foto de la denuncia',
    img: PoliceComplaint,
  },
];

export const IncidentsSides: any = {
  front: {
    title: 'Subí una foto de los daños en el frente de tu auto',
    button: 'Foto del frente del auto',
  },
  back: {
    title: 'Subí una foto de los daños de la parte de atrás de tu auto',
    button: 'Foto de la parte de atrás del auto',
  },
  right: {
    title: 'Subí una foto de los daños del lado derecho de tu auto',
    button: 'Foto del lado derecho del auto',
  },
  left: {
    title: 'Subí una foto de los daños del lado izquierdo de tu auto',
    button: 'Foto del lado izquierdo del auto',
  },
  windshield: {
    title: 'Ahora subí una foto de los daños en el parabrisas de tu auto',
    button: 'Foto del parabrisas del auto',
  },
};

export const SINISTER_TYPE_FIRE = 'fire';
export const SINISTER_TYPE_FLOOD = 'flood';
export const SINISTER_TYPE_HAIL = 'hail';
export const SINISTER_TYPE_ROBBERY = 'robbery';
export const SINISTER_TYPE_DAMAGE = 'damage';
export const SINISTER_TYPE_CRASH = 'crash';

export const original_crash = {
  crash: [
    {
      title: 'Tipo de daños',
      content: <TypeOfDamage />,
      order: 1,
    },
    {
      title: 'Revisión',
      content: <SinisterSummary />,
      order: 9,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
      order: 10,
    },
  ],
};

export const original_robbery = {
  robbery: [
    {
      title: 'Robo o hurto',
      content: <TypeOfTheft />,
      order: 1,
    },
    {
      title: 'Revisión',
      content: <SinisterSummary />,
      order: 14,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
      order: 15,
    },
  ],
};

export const incidentRoad: any = {
  crash: [
    {
      title: 'Tipo de daños',
      content: <TypeOfDamage />,
      order: 1,
    },
    {
      title: 'Revisión',
      content: <SinisterSummary />,
      order: 9,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
      order: 10,
    },
  ],
  damage: [
    {
      title: 'Tipo de daño propio',
      content: <Damage />,
      order: 1,
    },
    {
      title: 'Robo',
      content: <SelectRobbery />,
      order: 2,
    },
    {
      title: 'Revisión',
      content: <SinisterSummary />,
      order: 14,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
      order: 15,
    },
  ],
  robbery: [
    {
      title: 'Robo o hurto',
      content: <TypeOfTheft />,
      order: 1,
    },
    {
      title: 'Revisión',
      content: <SinisterSummary />,
      order: 14,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
      order: 15,
    },
  ],
  fire: [
    {
      title: 'Revisión',
      content: <SinisterSummary />,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
    },
  ],
  hail: [
    {
      title: 'Revisión',
      content: <SinisterSummary />,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
    },
  ],
  flood: [
    {
      title: 'Revisión',
      content: <SinisterSummary />,
    },
    {
      title: 'Revisión',
      content: <FinishStep />,
    },
  ],
};
